import React, { useEffect, useState } from "react";
import ProductTable from "./components/productTable";
import { getAllProducts } from "../../../api/Products";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { Link } from "react-router-dom";

const ProductsDashboard = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    
    const productsPerPage = 9 ;

  useEffect(() => {
    const initialFetch = async () => {
      setLoading(true);
      setProducts([]);

      const data = await getAllProducts(productsPerPage, page);

      setProducts(data);
      setLoading(false);
    };

    initialFetch();
  }, [page]);

  console.log(products);
  

  const Pagination = () => (
    <div className="flex flex-col items-center mt-5">
      {/* Help text */}
      <span className="text-sm text-gray-700 dark:text-gray-400">
        Showing{" "}
        <span className="font-semibold text-gray-900 dark:text-white">{productsPerPage*(page-1)}</span>{" "}
        to{" "}
        <span className="font-semibold text-gray-900 dark:text-white">{productsPerPage*page} </span>{" "}
        Entries
      </span>
      <div className="inline-flex mt-2 xs:mt-0">
        {/* Buttons */}
        <button className="flex items-center justify-center px-4 h-10 text-base font-medium text-white bg-[#005CB9] border-0 border-s rounded-e hover:bg-blue-500 disabled:bg-blue-200"
        
        onClick={() => setPage(page - 1)}
        disabled={page<2 || page == 1}
        >
          <i className="fa-solid fa-chevron-left w-3.5 h-3.5 me-2 rtl:rotate-180"></i>
          {/* <FontAwesomeIcon icon={faChevronLeft} className="w-3.5 h-3.5 me-2 rtl:rotate-180" /> */}
          {" "}Prev
        </button>
        <button
        disabled={products.length<productsPerPage}
        className="flex items-center justify-center px-4 h-10 text-base font-medium text-white bg-[#005CB9] border-0 border-s rounded-e hover:bg-blue-500 disabled:bg-blue-200"
                onClick={() => setPage(page + 1)}

        >
          Next
          <i className="fa-solid fa-chevron-right w-3.5 h-3.5 ms-2 rtl:rotate-180"></i>
          {/* <FontAwesomeIcon icon={faChevronRight} className="w-3.5 h-3.5 ms-2 rtl:rotate-180" /> */}
        </button>
      </div>
    </div>
  );

  return (
    <>
      <div className="p-4">
        <h3>products</h3>
        <hr />
      </div>
      <div className="p-4 h-[75vh] flex flex-col items-center justify-start rounded border-gray-300 shadow-2xl">
        <div className=" w-full flex items-end justify-end">

        <Link to="/dashboard/main/product/addproduct" className="text-white bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">
        <i className="fa-solid fa-circle-plus me-2"></i>
            Add Product</Link>

   
        </div>
        
        <br/>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <ProductTable products={products} />
            <Pagination/>
          </>
        )}
      </div>
    </>
  );
};

export default ProductsDashboard;
